<template><SimpleModuleDashboard :module-id="Modules.COSTOS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'crudPriceListSuppliers', reference: 'crudPriceListSuppliers', route: 'CostsStaffPriceListSuppliers', tone: 'primary' },
  { id: 'crudProductSuppliersByBarcode', reference: 'crudProductSuppliersByBarcode', route: 'CostsStaffProductSuppliersByBarcode', tone: 'primary' },
  { id: 'crudImportLog', reference: 'crudImportLog', route: 'CostsStaffPriceListSuppliersImportLog', tone: 'primary', group: 'Configuraciones' },
  { id: 'crudUpdateExternal', reference: 'crudUpdateExternal', route: 'CostsStaffPriceListSuppliersUpdateExternal', tone: 'primary' },
  { id: 'configuration', reference: 'configuration', route: 'CostsStaffConfiguration', tone: 'primary', group: 'Configuraciones' },
] }) }
</script>
